export default __webpack_public_path__ + "static/media/Chow.3fc1e277.jpg";